import { createFileRoute } from '@tanstack/react-router'

import { Frame } from '@/components/frame'
import { PageHeader } from '@/components/page-header'
import { TrainingList } from '@/components/training/training-list'
import { TrainingUsagePanel } from '@/components/training/training-usage'

/**
 * Lot 38a : les formations vidéo de tous les clients (menu global). Lot 38b :
 * la consommation ElevenLabs du mois, agents et personnes, face au quota.
 */
export const Route = createFileRoute('/_app/formations/')({
  component: TrainingsPage,
})

function TrainingsPage() {
  return (
    <div className="space-y-5">
      <PageHeader title="Formations" />
      <Frame>
        <h2 className="mb-3 font-semibold tracking-tight">Voix ElevenLabs ce mois-ci</h2>
        <TrainingUsagePanel />
      </Frame>
      <Frame>
        <TrainingList />
      </Frame>
    </div>
  )
}
